import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { useEffect, useState } from 'react';

import ApolloClientService from '../services/ApolloClientService';
import AuthService from '../services/AuthService';
import Config from '../config';
import MembershipService from '../../membership/services/MembershipService';
import User from '../../membership/models/User';
import { singletonHook } from 'react-singleton-hook';

let client: ApolloClient<NormalizedCacheObject>;

const useSingletonUser = () => {
  /** Value indicating whether the user is loading. */
  const [userLoading, setUserLoading] = useState<boolean>();
  /** Error message encountered during saving. */
  const [userError, setUserError] = useState<string>();
  /** User loaded from server. */
  const [user, setUser] = useState<User>(null);

  client = client || ApolloClientService.create(Config.MEMBERSHIP_GQL);

  useEffect(() => {
    setUserLoading(true);
    setUserError(undefined);
    AuthService.isAuthenticatedAsync()
      .then(async (oidcUser) => {
        if (oidcUser) {
          const userkey = +oidcUser.profile.sub;
          const user = await MembershipService.getUserByKeyAsync(userkey);

          if (user) {
            setUser(user);
            AuthService.BrackenUser = user;
          } else {
            AuthService.login();
          }
        } else {
          AuthService.login();
        }
        setUserLoading(false);
      })
      .catch((error) => {
        AuthService.login();
      });
  }, []);

  return {
    userLoading,
    userError,
    user,
    setUser
  };
};

interface IUseUser {
  userLoading?: boolean;
  userError?: string;
  user: User;
  setUser?: (user: User) => void;
}
const init: IUseUser = {
  user: undefined
};

export default singletonHook<IUseUser>(init, useSingletonUser);
